
<template>
  <div id="app">
    <div v-show="$route.path==='/sign-up' || $route.path==='/login' ? false : true"><navbar></navbar></div>
    <router-view/>
  </div>

  <!--<div id="app">-->
    <!--<img src="./assets/logo.png">-->
  <!--</div>-->
</template>

<script>
  import Navbar from "./components/Navbar";

  export default {
    name: "App",
    data() {
      return{};
    },
    components: {Navbar}
  }
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue